<form class="mt-4"
      [ngClass]="{row: hideLoginButton}"
      [formGroup]="loginForm"
      (ngSubmit)="login()"
      *ngIf="!showDeviceVerifyForm"
      >

  <div class="mb-3"
       [ngClass]="{'col-sm': hideLoginButton}">
    <label for="email" class="form-label">Email</label>
    <input type="email"
           class="form-control form-control-lg"
           formControlName="email"
           id="email"
           placeholder="Your email"
           yp-e2e-id="login-email-input">
    <div class="alert-container" *ngIf="submitted && email.errors">
      <div class="alert alert-danger"
           yp-e2e-id="login-email-validation-required"
           *ngIf="email.errors.required">Please enter an email address.</div>
      <div class="alert alert-danger"
           yp-e2e-id="login-email-validation-pattern"
           *ngIf="email.errors.pattern">Please enter a valid email address.</div>
    </div>
  </div>

  <div class="mb-3"
       [ngClass]="{'col-sm': hideLoginButton}">
    <label for="password" class="form-label">Password</label>
    <input type="password"
           class="form-control form-control-lg"
           formControlName="password"
           id="password"
           placeholder="Your password"
           yp-e2e-id="login-password-input">
    <div class="alert-container"
         yp-e2e-id="login-password-validation-required"
         *ngIf="submitted && password.errors">
      <div class="alert alert-danger">Please enter a password.</div>
    </div>
    <div class="alert-container"
         yp-e2e-id="login-password-validation-pattern"
         *ngIf="submitted && loginError">
      <div class="alert alert-danger">Sorry, the email address or password entered is incorrect. Please try again.</div>
    </div>
  </div>

  <div class="d-flex align-items-center justify-content-between mt-3">
    <div class="form-check">
      <!--      <input class="form-check-input" type="checkbox" value="" id="rememberMe">-->
      <!--      <label class="form-check-label" for="rememberMe">Remember me</label>-->
    </div>
    <a routerLink="/login/reset-password"
       class="royal-blue"
       title="Reset your password"
       yp-e2e-id="forgot-password-button">Forgot password?</a>
  </div>
  <div class="d-flex align-items-center justify-content-center mt-4"
    *ngIf="!hideLoginButton">
    <button class="button button-sm button-primary w-100"
            [appButtonLoader]="isLoading"
            yp-e2e-id="login-button">Log in</button>
  </div>
  <button class="hide-input-with-margin"
          *ngIf="hideLoginButton"
          type="submit">Empty hidden</button>
</form>
<div *ngIf="showDeviceVerifyForm">
  <app-verify-device [userId]="userId" (deviceVerifyDone)="verifyDevice($event)"></app-verify-device>
</div>
